/**
 * Név: guriga — Globális „kérem várjon” (spinner) állapotkezelő.
 * Cél: Egységesen kezelni a hálózati kérések alatt megjelenő betöltés-jelzőt.
 *
 * Működés:
 *  - másold ezt a fájlt src/stores alá
 *  - józan ésszel módosítsd a axios.ts és App.vue fájlokat ennek a kódnak a lenti megjegyzésében található módon
 *
 * Használat:
 *  - bekötés után nem kell különösebben csinálni semmit
 */

import { ref } from 'vue'

const showGuriga = ref(false)
const kereseXama = ref(0)

export function guriga() {
  function keres_elinditasa() {
    kereseXama.value++
    showGuriga.value = true
  }
  function keres_befejezese() {
    kereseXama.value--
    if (kereseXama.value <= 0) {
      showGuriga.value = false
      kereseXama.value = 0
    }
  }
  return { showGuriga, keres_elinditasa, keres_befejezese }
}

/*
Használat (guriga)

- axios.ts bővítése
- App.vue bővítése

----------------------------------------

axios.ts

import { guriga } from '@/stores/guriga'
const { keres_elinditasa, keres_befejezese } = guriga()
declare module "axios" {
  export interface AxiosRequestConfig {
    showSpinner?: boolean
  }
}

// ...

api.interceptors.request.use(
  (config) => {
    if (config.showSpinner !== false) {
      keres_elinditasa()
    }
    return config
  },
  (error) => {
    keres_befejezese()
    return Promise.reject(error)
  }
)
api.interceptors.response.use(
  (response) => {
    keres_befejezese()
    return response
  },
  (error) => {
    keres_befejezese()
    return Promise.reject(error)
  }
)

----------------------

App.vue

<script setup lang="ts">
import { guriga } from "./stores/guriga";
import ProgressSpinner from "primevue/progressspinner"
const { showGuriga } = guriga()
</script>

<template>
  <router-view />
  <div v-if="showGuriga" class="fixed inset-0 flex items-center justify-center z-[9999]">
    <ProgressSpinner strokeWidth="8" style="width:50px; height:50px"
      :pt="{
        circle: { class: '!stroke-sky-500 !opacity-100' }
      }"/>
  </div>
</template>

*/
